module.exports = __webpack_public_path__ + "static/img/11.6df5a37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/11.png
// module id = rygo
// module chunks = 0